import { render } from "./SettingsSubscriptionSection.vue?vue&type=template&id=81d87d08"
import script from "./SettingsSubscriptionSection.vue?vue&type=script&lang=js"
export * from "./SettingsSubscriptionSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__